// MapTypeStyle https://developers.google.com/maps/documentation/javascript/reference/map#MapTypeStyle
export const MAP_STYLES: Array<{
  elementType?: string
  featureType?: string
  stylers: Array<{
    color?: string
    visibility?: string
    weight?: number
  }>
}> = [
  {
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#E2E8EB',
      },
    ],
  },
  {
    elementType: 'labels.text',
    stylers: [
      {
        color: '#7a93a4',
      },
      {
        weight: 1,
      },
    ],
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [
      {
        color: '#f5f5f5',
      },
    ],
  },
  {
    featureType: 'administrative.land_parcel',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'landscape',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'labels',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [
      {
        color: '#a9b0c7',
      },
      {
        visibility: 'on',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ffffff',
      },
    ],
  },
  {
    featureType: 'road',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'transit',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        color: '#A4CDF0',
      },
    ],
  },
]

export const MAP_POINT_PATH = `M18 0C11.3833 0 6 5.38334 6 12C6 13.9864 6.49662 15.9558 7.4407 17.7026L17.3438 35.6133C17.4756 35.8521 17.7269 36 18 36C18.2732 36 18.5244 35.8521 18.6562 35.6133L28.563 17.6967C29.5034 15.9558 30 13.9863 30 12C30 5.38334 24.6167 0 18 0ZM18 18C14.6917 18 12 15.3084 12 12C12 8.69168 14.6917 6.00005 18 6.00005C21.3084 6.00005 24 8.69168 24 12C24 15.3084 21.3084 18 18 18Z`

